export const isFeatured = article =>
  article.acf &&
  article.acf.featured_article &&
  article.acf.featured_article[0] === 'true'
